/**
 * Display formatting, shared by every Money Manager screen.
 *
 * These live here rather than on the dashboard because the dashboard imports
 * from the recurring module and the recurring screen needs `formatCents` — a
 * cycle Angular tolerates unpredictably, surfacing as undefined-at-init rather
 * than a compile error.
 */

/** Whole dollars — these screens show magnitudes, not ledger precision. */
export function formatCents(cents: number): string {
  const dollars = Math.round(Math.abs(cents) / 100);
  const grouped = dollars.toLocaleString('en-US');
  return `${cents < 0 ? '-' : ''}$${grouped}`;
}

export function formatDeltaLabel(deltaPct: number | null): string {
  if (deltaPct === null) return 'no prior month';
  const arrow = deltaPct < 0 ? '↓' : '↑';
  return `${arrow} ${Math.abs(deltaPct).toFixed(1)}% vs last month`;
}
